module.exports = __webpack_public_path__ + "images/ac0a35af2edcb2e48fe24ee797872463.jpg";